/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleDiscrepanciesRequest } from '../../models/article-discrepancies-request';
import { KeyType } from '../../models/key-type';
import { VirtualArticleDiscrepanciesResponse } from '../../models/virtual-article-discrepancies-response';

export interface SetBundleGroupVirtualArticleDiscrepancies$Params {
  organizationSiteKey: KeyType;
  groupKey: string;
  virtualArticleKey: string;
      body: ArticleDiscrepanciesRequest
}

export function setBundleGroupVirtualArticleDiscrepancies(http: HttpClient, rootUrl: string, params: SetBundleGroupVirtualArticleDiscrepancies$Params, context?: HttpContext): Observable<StrictHttpResponse<VirtualArticleDiscrepanciesResponse>> {
  const rb = new RequestBuilder(rootUrl, setBundleGroupVirtualArticleDiscrepancies.PATH, 'put');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('groupKey', params.groupKey, {});
    rb.path('virtualArticleKey', params.virtualArticleKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VirtualArticleDiscrepanciesResponse>;
    })
  );
}

setBundleGroupVirtualArticleDiscrepancies.PATH = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/{virtualArticleKey}/discrepancies';
